import React from "react";
import {Button, Card, CardActions, CardContent, Fade, IconButton, Modal, TextField} from "@material-ui/core";
import {Close} from "@material-ui/icons";
import {Typography} from "../../../../components/Wrappers/Wrappers";
import CopyToClipboard from "../CopyToClipboard";
import {isWidthUp} from "@material-ui/core/withWidth";
import useStyles from "./styles";

const JobDashboardModal = ({handleModalClose, modalOpen, width}) => {
    const classes = useStyles();


    const rowsMax = () => {
        const length = modalText.split(/\r\n|\r|\n/).length;
        if (isWidthUp('md', width)) {
            return length + 2;
        }
        return 3
    }


    const modalText = `Hallo JobNinja Team,

Wir möchten das Stellenangebot ändern.

Wir möchten den Stellentitel ändern => neuer Stellentitel

Wir möchten das HTML ändern. [BITTE FÜGEN SIE DAS NEUE HTML/ZIP/PDF IN IHRER E-MAIL AN].

Wir möchten einige andere Informationen ändern: Stellenort, Stellenart, Stellenkategorie...

Wir wollen die Jobanzeige offline stellen.

Zusätzliche Informationen/Änderungen: z.B.: Emailadresse für die Bewerbung, Link zum Bewerbungsformular, Firmenlogo...

Beste Grüße,`

    return (

            <Modal
                open={modalOpen}
                onClose={handleModalClose}
                aria-labelledby="simple-modal-title"
                aria-describedby="simple-modal-description"
            >
                <Fade in={modalOpen} timeout={500}>
                    <Card className={classes.modalRoot}>
                        <IconButton onClick={handleModalClose} className={classes.modalExit}>
                            <Close/>
                        </IconButton>
                        <CardContent>
                            <Typography gutterBottom variant="h5" component="h2">
                                Anzeige anpassen
                            </Typography>
                            <Typography variant="body2" color="textSecondary" component="p">
                                Damit wir Ihre Anfrage schneller bearbeiten können, bitten wir Sie den unten
                                stehenden Text zu kopieren, entsprechend Ihren Bedürfnissen abzuändern und an <a
                                href={'mailto:anzeigen@jobninja.com'}
                                target={'_blank'} rel="noopener noreferrer">anzeigen@jobninja.com</a> zu senden.
                            </Typography>
                            <br/>
                            <TextField
                                label="Ihre E-Mail"
                                multiline
                                disabled
                                rowsMax={rowsMax()}
                                value={modalText}
                                fullWidth
                                variant="outlined"
                            />
                        </CardContent>
                        <CardActions>
                            <CopyToClipboard TooltipProps={{placement: 'right'}}>
                                {({copy}) => (
                                    <Button
                                        variant="contained"
                                        size="medium"
                                        color="secondary"
                                        onClick={() => copy(modalText)}
                                    >Text kopieren
                                    </Button>
                                )}
                            </CopyToClipboard>
                        </CardActions>
                    </Card>
                </Fade>
            </Modal>

    )
}


export default JobDashboardModal;